import React from 'react';
import { createNestedClassName } from '../helpers';
export var TableHeader = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.columns, columns = _c === void 0 ? [] : _c, _d = _a.nested, nested = _d === void 0 ? false : _d;
    if (!columns) {
        return null;
    }
    return (React.createElement("thead", { className: createNestedClassName("table-header", nested) },
        !title ? null : (React.createElement("tr", { className: createNestedClassName("table-header-title", nested) },
            React.createElement("td", { colSpan: columns.length }, title))),
        React.createElement("tr", { className: createNestedClassName("table-header-columns", nested) }, columns.map(function (column, index) { return (React.createElement("th", { key: index, className: createNestedClassName("table-header-column", nested) }, column)); }))));
};
//# sourceMappingURL=TableHeader.js.map